import React from "react";
import { createRoot } from "react-dom/client";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

import App from "./components/App/App";
import { msalConfig } from "./authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root container missing in index.html");
}

const root = createRoot(container);



root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);

// import React from "react";
// import ReactDOM from "react-dom";

// import App from "./components/App/App";
// // import "bootstrap/dist/css/bootstrap.min.css";

// ReactDOM.render(
//   <React.StrictMode>
//       <App />
//   </React.StrictMode>,
//   document.getElementById("root")
// );


// import React, { useEffect, useState } from "react";
// // import ReactDOM from "react-dom/client";
// // import { ReactDOM  } from "react-dom/client";
// import { createRoot } from "react-dom/client";

// import { PublicClientApplication } from "@azure/msal-browser";
// import { MsalProvider } from "@azure/msal-react";

// import { msalConfig } from "./authConfig";
// // import App from "./App";
// import App from "./components/App/App";

// const msalInstance = new PublicClientApplication(msalConfig);

// const RootApp: React.FC = () => {
//   const [isInitialized, setIsInitialized] = useState<boolean>(false);

//   useEffect(() => {
//     msalInstance.initialize().then(() => {
//       setIsInitialized(true);
//     });
//   }, []);

//   if (!isInitialized) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <MsalProvider instance={msalInstance}>
//       <App />
//     </MsalProvider>
//   );
// };

// const container = document.getElementById("root");

// if (!container) {
//   throw new Error("Root container missing in index.html");
// }

// // const root = ReactDOM.createRoot(container);
// const root = createRoot(container);

// root.render(
//   <React.StrictMode>
//     <RootApp />
//   </React.StrictMode>
// );

